/* eslint-disable */
import moment from 'moment';
import {
	useEffect,
	useMemo,
	useState
} from 'react';
import { connect } from 'react-redux';
// import { useHistory } from 'react-router';
import analyticsAction from '../../../../Actions/analytics.actions';
import { DefectImageModal } from '../../../../Components/Modals';
import { liveQCServices } from '../../../../Services/LiveQC';
import styles from './AiDispatchImagesPage.module.scss';

import {
	analyticsConstants, modalTypes, urls
} from '../../../../Constants';
import commonAnalyticsServices from '../../../../Services/Analytics Services/common-analytics.services';
import { ImagesResult } from '../../../../Components/ImagesResult';
import { modalActions } from '../../../../Actions';
import ImagesFinder from '../../../../Components/ImagesFinder/ImagesFinder';
import { Button, Chip } from '@mui/material';
import { Filter } from 'lucide-react';
import drawerActions from '@/Actions/drawer.actions';
import { filtersInfoChip } from '@/Helpers';
import { SelectPicker } from 'rsuite';

// const source =
// 'https://www.thespruceeats.com/thmb/vJUFf6L4p8y9Cn_1pE9Z7Ua9uok=/3000x2001/filters:fill(auto,1)/indian-style-burger-1957599-hero-01-266103a4bb4e4ee7b5feb4da2d2e99da.jpg';

const AiDispatchImagesPage = (props) => {
	const [filters, setFilters] = useState({
		store: null,
		processTypes: null,
		products: [],
		brand: null,
		identification: 'Both',
		dateRange: {
			active: false,
			from: new Date(),
			to: new Date(),
		},
	});

	const {
		updateImagesList,
		allImagesResults,
		fetchImages,
		resetImages,
		toggleModal,
		toggleFiltersDrawer,
	} = props;

	useEffect(() => {
		resetImages(analyticsConstants.RESET_AI_DISPATCH_ANALYSIS);
	}, []);

	const [pageLimit, setPageLimit] = useState(6);

	const submitFindRequest = ({
		store = null,
		processTypes = null,
		products = [],
		dateRange = {},
		brand = null,
		identification,
		skuType,
	}) => {
		resetImages(analyticsConstants.RESET_AI_DISPATCH_ANALYSIS);
		setFilters({
			store,
			processTypes,
			products,
			dateRange,
			brand,
			identification,
			skuType,
		});
		const data = {
			storeId: store?.id,
			processTypes: processTypes?.id,
			products: products?.id,
			brandId: brand?.id,
			qcType: 'DISPATCH',
			identification,
			skuType: skuType?.toUpperCase(),
			dateRangeFilter: dateRange?.active
				? {
					from: moment(dateRange?.from).format('YYYY-MM-DD'),
					to: moment(dateRange?.to).format('YYYY-MM-DD'),
				}
				: {},
		};
		fetchImages({
			entity: 'AI_DISPATCH_ANALYSIS',
			method: 'FIND_IMAGES',
			req: {
				data,
				params: {
					limit: pageLimit,
				},
			},
		});
	};

	const fetchGrnImagesById = async ({ page, id: productId }, index) => {
		const response =
			await commonAnalyticsServices.fetchImagesById({
				params: {
					page,
					limit: pageLimit,
				},
				data: {
					storeId: filters?.store?.id,
					brandId: filters?.brand?.id,
					processTypes: filters?.processTypes?.id,
					identification: filters?.identification,
					productId,
					qcType: 'DISPATCH',
					dateRangeFilter: filters?.dateRange?.active
						? {
							from: moment(filters?.dateRange?.from).format(
								'YYYY-MM-DD'
							),
							to: moment(filters?.dateRange?.to).format(
								'YYYY-MM-DD'
							),
						}
						: {},
				},
			});

		const { data = [] } = response;
		updateImagesList(index, data, 'AI_DISPATCH_ANALYSIS', 'SET_AI_DISPATCH_IMAGES');
		return data;
	};

	const fetchQCData = async (qcId) => {
		try {
			const req = {
				params: {
					qcId,
				},
			};

			const { data = null } = await liveQCServices.getPastData(req);

			return data;
		} catch {
			return null;
		}
	};

	const totalValues = useMemo(() => {
		let totalShown = 0;
		let typeOfProducts = 0;
		let totalCount = 0;
		allImagesResults?.forEach((product) => {
			if (product?.Annotation.length > 0) {
				totalShown += product?.Annotation?.length ?? 0;
				typeOfProducts++;
			}
			totalCount += product?.count ?? 0;
		});
		return {
			totalShown,
			totalCount,
			typeOfProducts,
		};
	}, [allImagesResults]);

	const onItemClick = async ({ annotation, item: product }) => {
		const qcData = await fetchQCData(annotation.qcId);
		const item = {
			source: annotation.image,
			name: qcData?.ProductName,
			product,
			date: qcData?.QCTime,
			link:
				qcData != null
					? `${urls.EXTENSION}${urls.PAST_QC}/${qcData?.itemId}?id=${qcData?.id}`
					: null,
		};
		toggleModal(true, {
			item,
		});
	};

	const filtersInfo = {
		header : {
			store : false,
			date : false,
			statusAndTypes : false,
			product : false,
			process : false,
		},
		store : {
			text : 'Store',
			show : true,
		},
		processType : {
			text : 'Process Types',
			show : true,
		},
		skuType : {
			text : 'SKU Type',
			show : true,
		},
		product : {
			text : 'Product',
			show : true,
		},
		identificationType : {
			text : 'Identification Type',
			show : true,
		},
		timeType : {
			text : 'Date Time Type',
			show : true,
		},
		dateRange : {
			text : 'Date Range',
			show : true,
		},
	}

	const exportInfo = {
		hideExportAccordian : true,
	};

	return (
		<div className={styles.root}>
			<DefectImageModal />
			<ImagesFinder
				onSubmit={submitFindRequest}
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
			/>
			<div className='flex justify-between m-4 '>
				<span className='font-bold text-[16px]'>Ai Dispatch Images </span>
				<Button
					onClick={() => {
						toggleFiltersDrawer(true);
					}}
					className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
				>
					<span>Filter</span>
					<Filter className='size-4' />
				</Button>
			</div>
			{filtersInfoChip(filtersInfo, filters)}
			<div className='flex items-center gap-2'>
				<span>
					Page Limit : 
				</span>
				<SelectPicker
					data={[6, 25, 50, 100].map((item) => ({
						label: item,
						value: item,
					}))}
					value={pageLimit}
					onChange={(value) => setPageLimit(value)}
					searchable={false}
					className='w-[200px]'
				/>
			</div>
			
			{allImagesResults?.length !== 0 && (
				<div className={styles.numbers}>
					<div className={styles.element}>
						Total Count:
						<span>{totalValues?.totalCount}</span>
					</div>
					{/* <div className={styles.element}>
						Total Showing
						<span>{totalValues?.totalShown}</span>
					</div> */}
					<div className={styles.element}>
						Type of Products:
						<span>{totalValues?.typeOfProducts}</span>
					</div>
				</div>
			)}
			<div className={styles['image-results']}>
				{allImagesResults?.map((currentItem, index) => {
					return (
						currentItem.Annotation.length > 0 && (
							<ImagesResult
								key={currentItem?.id}
								showLoadMore
								fetchMoreImages={(req) => {
									fetchGrnImagesById(req, index);
								}}
								onItemClick={onItemClick}
								currentItem={currentItem}
								clickable
								fetchQCData={fetchQCData}
							/>
						)
					);
				})}
				{allImagesResults?.length === 0 && (
					<p className={styles.fallback}>No items to display</p>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { FIND_IMAGES: allImagesResults } = state.analytics.AI_DISPATCH_ANALYSIS;

	return {
		allImagesResults,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchImages: (...args) => {
			dispatch(analyticsAction.gateway(...args));
		},
		updateImagesList: (...args) => {
			dispatch(analyticsAction.updateImagesList(...args));
		},
		resetImages: (type) => {
			dispatch(analyticsAction.resetImages(type));
		},
		toggleModal: (show, data = {}) => {
			dispatch(
				modalActions.toggleModal(modalTypes.DEFECT_IMAGE, show, data)
			);
		},
		toggleFiltersDrawer: (...args) => {
			dispatch(drawerActions.toggleFiltersDrawer(...args));
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AiDispatchImagesPage);
